import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { overrideConsole } from './logger/setupConsoleOverrides';
import { SENTRY_DSN, SENTRY_ENVIRONMENT } from './config';

import './tailwind-compiled.css';
Sentry.init({
  dsn: SENTRY_DSN,
  tracesSampleRate: 1.0,
  environment: SENTRY_ENVIRONMENT || process.env.NODE_ENV,
});

overrideConsole();

// Dynamic load HubSpot script
(function(d, s, id) {
  if (!d.getElementById(id)) {
    const script = d.createElement(s);
    script.id = id;
    script.async = true;
    script.defer = true;
    script.src = 'https://js.hs-scripts.com/45002546.js';
    d.getElementsByTagName('head')[0].appendChild(script);
  }
})(document, 'script', 'hs-script-loader');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
